<template>
    <div style="padding: 10% 0 10px" v-show="isShowEmpty">
        <p align="center" style="color:#aeaeae"><Icon :size="30" type="ios-folder-outline"></Icon></p>
        <p align="center" style="font-size: 15px; color:#aeaeae">Empty</Icon></p>
    </div>
</template>

<script>
export default {
    props: {
        payload: {
            type: [Array, Object, String, Number],
            required: true
        }
    },
    computed: {
        isShowEmpty() {
            if ( typeof this.payload === Array && this.payload.length == 0 )
                return true;
            return false;
        }
    },
    mounted() {
        console.log(this.payload)
    },
}
</script>